package team.platforma.multiplatform_material_extension.ui.check_box

import androidx.compose.material3.Checkbox
import androidx.compose.material3.CheckboxColors
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import team.platforma.multiplatform_material_extension.ui.core.global_style.takeGlobalCheckboxColors
import team.platforma.multiplatform_material_extension.util.forms.FormProperties
import team.platforma.multiplatform_material_extension.util.forms.rememberForms

@Composable
fun ExtraCheckBox(
    checked: Boolean,
    onCheckedChange: ((Boolean) -> Unit),
    modifier: Modifier = Modifier,
    enabled: Boolean = true,
    formProperties: FormProperties? = null,
    colors: CheckboxColors? = null
) {

    val forms by rememberForms()
    val form = formProperties ?: FormProperties(forms, key = "")

    LaunchedEffect(form.key) {
        form.form.initValue(form.key, checked.toString())
        form.form.changeValue(form.key, checked.toString())
        form.form.setValidateState(form.key, checked)
    }


    var mChecked by remember { mutableStateOf(false) }

    LaunchedEffect(checked) {
        mChecked = checked
    }

    var mEnabled by remember { mutableStateOf(true) }

    LaunchedEffect(enabled) {
        mEnabled = enabled
    }


    Checkbox(
        checked = mChecked,
        onCheckedChange = { change ->
            form.form.changeValue(form.key, change.toString())
            form.form.setValidateState(form.key, change)
            onCheckedChange(change)
        },
        modifier = modifier,
        enabled = mEnabled,
        colors = colors ?: takeGlobalCheckboxColors()
    )
}